import Vue from 'vue';
import injector from 'vue-inject';
import store from '../store';

let api     = injector.get('api'),
    popup   = injector.get('popup'),
    status  = injector.get('status');

class Verification {
    create (params) {
        this.data = params;
    }

    loadVerificationFiles () {
        return new Promise((resolve, reject) => {
            Vue.http.get(api.user.verification.get).then(response => {
                store.commit('setVerificationFiles', response.data.data.results);
                resolve ();
            }, error => {
                if (status['status' + error.status]) {
                    status['status' + error.status]();
                } else {
                    popup.show(error.data.errors[0].message);
                }
                reject();
            });
        });
    }

    sendFiles (filesList) {
        return new Promise((resolve, reject) => {
            Vue.http.post(api.user.verification.request, {
                files: filesList
            }).then(() => {
                popup.show('Upload success.');
                resolve ();
            }, error => {
                if (status['status' + error.status]) {
                    status['status' + error.status]();
                } else {
                    store.commit('modals', {
                        modal: 'alert',
                        data: {
                            visible: true,
                            reload: false,
                            message: error.data.errors[0].message
                        }
                    });
                }
                reject();
            });
        });
    }
}

injector.service('verification', Verification);



// WEBPACK FOOTER //
// ./src/services/verification.js